import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  NavDropdown,
  Card,
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { CarBus, OldComputerIcon } from "../Icon";
import TypeAhead from "./TypeAhead";
import NavbarLink from "./NavbarLink";
import TangibleOverlayModal from "./Modal/TangibleOverlay";
import Axios from "axios";
import { downloadExcel } from "@helpers";
import { NotePencilIcon } from "@phosphor-icons/react";
const Asset = ({ CanI, handleResponse, handleError }) => {
  const [state, setState] = useState({
    properties_view: false,
    properties_map: false,
    properties_add: false,
    automobiles_view: false,
    automobiles_add: false,
    automobiles_valuation: false,
    tangibles_view: false,
    tangibles_add: false,
    intangibles_view: false,
    intangibles_add: false,
    leases_view: false,
    leases_add: false,
    notepad_access: false,
  });
  useEffect(() => {
    async function InitAsset() {
      setState({
        ...state,
        properties_view: await CanI("properties_view"),
        properties_map: await CanI("properties_map"),
        properties_add: await CanI("properties_add"),
        automobiles_view: await CanI("automobiles_view"),
        automobiles_add: await CanI("automobiles_add"),
        automobiles_valuation: await CanI("reports_auto_valuation"),
        tangibles_view: await CanI("tangibles_view"),
        tangibles_add: await CanI("tangibles_add"),
        intangibles_view: await CanI("intangibles_view"),
        intangibles_add: await CanI("intangibles_add"),
        leases_view: await CanI("leases_view"),
        leases_add: await CanI("leases_add"),
        notepad_access: await CanI("notepad_access"),
      });
    }
    InitAsset();
  }, []);
  const {
    properties_view,
    properties_add,
    properties_map,
    automobiles_view,
    automobiles_add,
    automobiles_valuation,
    tangibles_view,
    tangibles_add,
    intangibles_view,
    intangibles_add,
    leases_view,
    leases_add,
    notepad_access,
  } = state;

  return (
    <NavDropdown.ItemText className="p-0">
      <Accordion>
        {(properties_view || leases_view) && (
          <Card id="properties-toggle-list">
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="light"
                eventKey="properties-toggle-list"
              >
                <span className="text-dark">
                  <i className="fa fa-home" /> Properties
                </span>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="properties-toggle-list">
              <Card.Body className="p-0">
                <ListGroup>
                  <ListGroup.Item>
                    <>
                      {properties_view && (
                        <Accordion>
                          <Card id="owned-toggle-list">
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="owned-toggle-list"
                              >
                                <span className="text-dark">Owned</span>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="owned-toggle-list">
                              <Card.Body className="p-0">
                                <ListGroup>
                                  <ListGroup.Item>
                                    <NavbarLink
                                      to="/app/properties"
                                      className="dropdown-item"
                                      label={"List View"}
                                    />
                                  </ListGroup.Item>

                                  {properties_map && (
                                    <ListGroup.Item>
                                      <a
                                        href="/properties/map"
                                        className="dropdown-item"
                                      >
                                        Map
                                      </a>
                                    </ListGroup.Item>
                                  )}
                                  {properties_add && (
                                    <ListGroup.Item>
                                      <NavbarLink
                                        to="/app/properties/add"
                                        className="dropdown-item"
                                        label={"Add"}
                                      />
                                    </ListGroup.Item>
                                  )}
                                  <ListGroup.Item className="px-3">
                                    <TypeAhead
                                      component={"properties"}
                                      style={{ minWidth: "150px" }}
                                      type="text"
                                      className="form-control"
                                      placeholder="Search..."
                                    />
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      )}
                      {leases_view && (
                        <Accordion>
                          <Card id="leased-toggle-list">
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="leased-toggle-list"
                              >
                                <span className="text-dark">Leased</span>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="leased-toggle-list">
                              <Card.Body className="p-0">
                                <ListGroup>
                                  <ListGroup.Item>
                                    <NavbarLink
                                      to="/app/leases"
                                      className="dropdown-item"
                                      label={"List View"}
                                    />
                                  </ListGroup.Item>

                                  {leases_add && (
                                    <ListGroup.Item>
                                      <NavbarLink
                                        to="/app/leases/add"
                                        className="dropdown-item"
                                        label={"Add"}
                                      />
                                    </ListGroup.Item>
                                  )}
                                  <ListGroup.Item className="px-3">
                                    <TypeAhead
                                      component={"leases"}
                                      style={{ minWidth: "150px" }}
                                      type="text"
                                      className="form-control"
                                      placeholder="Search..."
                                    />
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      )}
                    </>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
        {automobiles_view && (
          <Card id="vehicles-toggle-list">
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="light"
                eventKey="vehicles-toggle-list"
              >
                <span className="text-dark">
                  <CarBus width={17} height={17} /> Automobiles
                </span>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="vehicles-toggle-list">
              <Card.Body className="p-0">
                <ListGroup>
                  <ListGroup.Item>
                    <Link to="/app/automobiles" className="dropdown-item">
                      List
                    </Link>
                  </ListGroup.Item>
                </ListGroup>

                <ListGroup>
                  {automobiles_add && (
                    <ListGroup.Item>
                      <Link to="/app/automobiles/add" className="dropdown-item">
                        Add
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>

                {automobiles_valuation && (
                  <ListGroup>
                    <ListGroup.Item>
                      <Link
                        to="/app/automobiles/valuation-reports"
                        className="dropdown-item"
                      >
                        Valuation Reports
                      </Link>
                    </ListGroup.Item>
                  </ListGroup>
                )}

                <ListGroup.Item className="px-3">
                  <TypeAhead
                    component={"automobiles"}
                    style={{ minWidth: "150px" }}
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                  />
                </ListGroup.Item>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
        {tangibles_view && (
          <Card id="tangibles-toggle-list">
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="light"
                eventKey="tangibles-toggle-list"
              >
                <span className="text-dark">
                  <OldComputerIcon width={17} height={17} /> Personal Property
                </span>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="tangibles-toggle-list">
              <Card.Body className="p-0">
                <ListGroup>
                  <ListGroup.Item>
                    <Link to="/app/tangibles" className="dropdown-item">
                      List
                    </Link>
                  </ListGroup.Item>
                </ListGroup>

                <ListGroup>
                  {tangibles_add && (
                    <ListGroup.Item>
                      <Link to="/app/tangibles/add" className="dropdown-item">
                        Add
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
                <ListGroup>
                  <TangibleOverLay
                    handleResponse={handleResponse}
                    handleError={handleError}
                  />
                </ListGroup>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}

        {intangibles_view && (
          <Card id="intangibles-toggle-list">
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="light"
                eventKey="intangibles-toggle-list"
              >
                <span className="text-dark">
                  <i className="fas fa-dollar-sign" /> Complex Assets
                </span>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="intangibles-toggle-list">
              <Card.Body className="p-0">
                <ListGroup>
                  <ListGroup.Item>
                    <Link to="/app/intangibles" className="dropdown-item">
                      List
                    </Link>
                  </ListGroup.Item>
                </ListGroup>

                <ListGroup>
                  {intangibles_add && (
                    <ListGroup.Item>
                      <Link to="/app/intangibles/add" className="dropdown-item">
                        Add
                      </Link>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
      </Accordion>
      {notepad_access && (
        <Card>
          <Card.Body>
            <ListGroup>
              <ListGroup.Item>
                <NavbarLink
                  to="/notepad"
                  className="dropdown-item"
                  label={
                    <>
                      <NotePencilIcon weight="bold" />
                      Notepad
                    </>
                  }
                ></NavbarLink>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      )}
    </NavDropdown.ItemText>
  );
};

Asset.propTypes = { CanI: PropTypes.func };

export default Asset;

const TangibleOverLay = ({ handleResponse, handleError }) => {
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [overlay, setOverlay] = useState({});

  const getTemplate = async () => {
    const response = await Axios.get("/tangibles/get-overlay-template", {
      responseType: "blob",
    });
    downloadExcel(response.data, {
      name: "Tangible_Overlay",
      type: ".xlsx",
    });
  };
  const uploadOverlay = async () => {
    setLoading(true);
    const configs = { headers: { "content-type": "multipart/form-data" } };
    let formData = new FormData();
    formData.append("overlay", overlay);
    try {
      const response = await Axios.post(
        "/tangibles/upload-asset-overlay",
        formData,
        configs,
      );
      await handleResponse(response);
    } catch (error) {
      await handleError(error);
    }
    setLoading(false);
  };
  const handleSetOverlay = (event) => {
    if (event.target.files[0]) {
      setOverlay(event.target.files[0]);
    }
  };
  return (
    <Fragment>
      <ListGroup.Item>
        <Accordion>
          <Card>
            <Card.Header>
              <Accordion.Toggle
                as={Button}
                variant="light"
                eventKey="tangibles_overlay-toggle-list"
              >
                <span className="text-dark">Assets Overlay</span>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="tangibles_overlay-toggle-list">
              <Card.Body>
                <ListGroup>
                  <ListGroupItem
                    onClick={() => setModalShow(true)}
                    variant="secondary"
                    as={Button}
                  >
                    Assets Overlay Upload
                  </ListGroupItem>
                  <ListGroupItem
                    onClick={getTemplate}
                    variant="secondary"
                    as={Button}
                  >
                    Assets Overlay Template
                  </ListGroupItem>
                </ListGroup>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </ListGroup.Item>
      <TangibleOverlayModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleSetOverlay={handleSetOverlay}
        uploadOverlay={uploadOverlay}
        loading={loading}
      />
    </Fragment>
  );
};
